/* ALMA · Upsell de accesorios en el carrito (tema Dwell, 3-oct-2026). Basado en as-ctl.js (Fase 7C).
   Delegación de eventos en document: sobrevive a los re-render del drawer. Sin librerías. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__asUp) {
  window.__asUp = true;
  const seen = new Set();
  const money = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');

  const track = (name, data) => {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('alma_' + name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'alma_' + name }, data)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('alma:analytics', { detail: Object.assign({ name: name }, data) })); } catch (e) {}
  };
  window.almaTrack = track;

  const payload = (card, extra) => {
    const wrap = card.closest('[data-asctl]');
    const st = state(card);
    return Object.assign({
      source_product: card.dataset.srcTitle, source_product_id: card.dataset.src,
      recommended_product: card.dataset.title, recommended_product_id: card.dataset.pid,
      recommendation_position: Number(card.dataset.pos), discount_pct: Number(card.dataset.pct),
      regular_price: st.reg / 100, upsell_price: st.now / 100,
      cart_value_before: wrap ? Number(wrap.dataset.cartTotal) / 100 : null,
    }, extra || {});
  };

  // El drawer se re-renderiza por morph y reutiliza nodos: la caché va ligada al id de producto, no al elemento.
  const variants = (card) => { if (card.__vpid !== card.dataset.pid) { card.__vpid = card.dataset.pid; try { card.__v = JSON.parse(card.querySelector('[data-ctl-variants]').textContent); } catch (e) { card.__v = []; } } return card.__v; };
  const chosen = (card) => Array.from(card.querySelectorAll('[data-ctl-opt]')).sort((a, b) => a.dataset.ctlOpt - b.dataset.ctlOpt).map((el) => el.value);
  const match = (card) => { const c = chosen(card); if (c.some((x) => x === '')) return null; return variants(card).find((v) => v.o.every((o, i) => o === c[i])) || null; };
  const state = (card) => { const v = match(card) || variants(card)[0] || { p: 0 }; const pct = Number(card.dataset.pct); const now = Math.round(v.p * (100 - pct) / 100); return { reg: v.p, now: now, save: v.p - now }; };

  const refresh = (card) => {
    const st = state(card); const q = (s) => card.querySelector(s);
    if (q('[data-ctl-reg]')) q('[data-ctl-reg]').textContent = money(st.reg);
    if (q('[data-ctl-now]')) q('[data-ctl-now]').textContent = money(st.now);
    if (q('[data-ctl-save]')) q('[data-ctl-save]').textContent = money(st.save);
    const w = card.closest('[data-asctl]'); if (w && q('[data-ctl-delta]')) { const pct = Number(card.dataset.pct); const after = Math.round((Number(w.dataset.cartSub) + st.reg) * (100 - pct) / 100); q('[data-ctl-delta]').textContent = money(after - Number(w.dataset.cartTotal)); }
    const c = chosen(card); const btn = q('[data-ctl-add]'); const err = q('[data-ctl-err]');
    const complete = !c.some((x) => x === '');
    if (complete && !match(card)) { btn.disabled = true; err.textContent = 'Esta combinación está agotada. Prueba otro color o talla.'; }
    else { btn.disabled = false; err.textContent = ''; }
    // marca como no disponibles las tallas sin stock para el color elegido
    const size = q('select[data-ctl-size]');
    if (size) { const idx = Number(size.dataset.ctlOpt); Array.from(size.options).forEach((o) => { if (!o.value) return; const ok = variants(card).some((v) => v.o[idx] === o.value && v.o.every((x, i) => i === idx || c[i] === '' || x === c[i])); o.disabled = !ok; o.textContent = o.value + (ok ? '' : ' · agotada'); }); }
  };

  const observe = () => {
    document.querySelectorAll('[data-asctl-card]').forEach((card) => {
      const ww = card.closest('[data-asctl]'); const sig = card.dataset.pid + ':' + card.dataset.pct + ':' + (ww ? ww.dataset.cartSub : '');
      if (card.__sig !== sig) { const first = !card.__sig; card.__sig = sig; if (!first) { card.querySelectorAll('select[data-ctl-opt]').forEach((sel) => { if (sel.hasAttribute('data-ctl-size')) { sel.value = ''; } else { const d = Array.from(sel.options).find((o) => o.hasAttribute('selected')); sel.value = d ? d.value : sel.options[0].value; } sel.classList.remove('is-missing'); }); } refresh(card); const b = card.querySelector('[data-ctl-add]'); if (b && /Añadiendo/.test(b.textContent)) { b.textContent = b.dataset.label || 'Añadir'; } }
      if (card.__io) return; card.__io = true;
      const io = new IntersectionObserver((en) => { en.forEach((e) => { if (e.isIntersecting && !seen.has(card.dataset.pid)) { seen.add(card.dataset.pid); track('upsell_impression', payload(card)); } }); }, { threshold: 0.5 });
      io.observe(card);
    });
    const bar = document.querySelector('[data-asctl-pay]');
    if (bar) {
      const real = Array.from(document.querySelectorAll('#cart-drawer [name="checkout"]')).find((b) => b.getBoundingClientRect().width > 0) || null;
      if (real && bar.__target !== real) {
        if (bar.__io) bar.__io.disconnect();
        bar.__target = real;
        bar.__io = new IntersectionObserver((en) => { en.forEach((e) => { bar.__want = !e.isIntersecting; bar.classList.toggle('is-on', bar.__want); }); }, { threshold: 0.6 });
        bar.__io.observe(real);
      }
      // el morph del drawer restaura el atributo class: se reaplica el estado deseado
      if (typeof bar.__want === 'boolean') bar.classList.toggle('is-on', bar.__want);
    }
    document.querySelectorAll('[data-asdraw-msg]').forEach((m) => { if (m.__t) return; m.__t = true; const w = m.closest('[data-asctl]'); track('gift_draw_threshold_message_impression', { threshold_gap: Number(m.dataset.gap) / 100, cart_value: w ? Number(w.dataset.cartTotal) / 100 : null }); });
  };
  let tmr = 0; new MutationObserver(() => { if (tmr) return; tmr = setTimeout(() => { tmr = 0; observe(); }, 60); }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-pid', 'data-pct'] });
  observe();

  document.addEventListener('change', (ev) => {
    const el = ev.target; if (!(el instanceof Element) || !el.matches('[data-ctl-opt]')) return;
    const card = el.closest('[data-asctl-card]'); if (!card) return;
    el.classList.remove('is-missing'); refresh(card);
    const v = match(card); track('upsell_variant_selected', payload(card, { option_value: el.value, variant_id: v ? v.i : null }));
  });

  document.addEventListener('click', (ev) => {
    const t = ev.target instanceof Element ? ev.target : null; if (!t) return;
    const link = t.closest('.asctl-card__t, .asctl-card__img');
    if (link) { const c = link.closest('[data-asctl-card]'); if (c) track('upsell_click', payload(c, { click_target: 'product_link' })); return; }
    const btn = t.closest('[data-ctl-add]'); if (!btn) return;
    const card = btn.closest('[data-asctl-card]'); if (!card || btn.disabled) return;
    const err = card.querySelector('[data-ctl-err]');
    const missing = Array.from(card.querySelectorAll('select[data-ctl-opt]')).filter((s) => s.value === '');
    if (missing.length) { missing.forEach((s) => s.classList.add('is-missing')); err.textContent = 'Elige tu talla para añadirla.'; missing[0].focus(); track('upsell_click', payload(card, { click_target: 'cta_missing_size' })); return; }
    const v = match(card); if (!v) { refresh(card); return; }
    track('upsell_click', payload(card, { click_target: 'cta', variant_id: v.i }));
    const data = payload(card, { variant_id: v.i });
    const label = btn.textContent; btn.disabled = true; btn.textContent = 'Añadiendo…';

    const ids = Array.from(document.querySelectorAll('cart-items-component')).map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(v.i), quantity: 1 }], promise: deferred.promise }));

    fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.i, quantity: 1, properties: { _completa_look: card.dataset.src } }], sections: ids.join(','), sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) { throw new Error(res.description || res.message || 'No se pudo añadir'); }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'as-ctl', itemCount: 1, productId: card.dataset.pid, sections: res.sections, didError: false } });
          track('upsell_add_to_cart', Object.assign(data, { cart_value_after: cart.total_price / 100, cart_item_count_after: cart.item_count }));
          btn.disabled = false; btn.textContent = btn.dataset.label || label;
        });
      })
      .catch((e) => {
        deferred.resolve({ cart: null, detail: { didError: true, source: 'as-ctl' } });
        btn.disabled = false; btn.textContent = label; err.textContent = (e && e.message) || 'No se pudo añadir. Inténtalo de nuevo.';
      });
  });
}
